export enum COMPARATOR_TYPES {
  EQ = 'eq',
  CONTAINS = 'contains',
  CONTAINS_ALL = 'contains_all',
  GT = 'gt',
  LT = 'lt',
  GTE = 'gte',
  LTE = 'lte',
}

/**
 * Specify asc or desc order by order_by field.
 *
 * `asc`: from older to newer
 * `desc`: from newer to older
 */
export enum ORDER {
  DESC = 'desc',
  ASC = 'asc',
}
